module.exports = __webpack_public_path__ + "img/1.1897aaf9.jpg";